import React from 'react'

import Navbar from '../components/Navbar'
import Trending from '../components/Trending'

const Trendingpage = () => {
  return (
    <>
      <Navbar/>
      <Trending/>
    </>
  )
}

export default Trendingpage
